import { render, staticRenderFns } from "./RaddarPDPOld.vue?vue&type=template&id=17a69b90&scoped=true"
import script from "./RaddarPDPOld.vue?vue&type=script&lang=js"
export * from "./RaddarPDPOld.vue?vue&type=script&lang=js"
import style0 from "./RaddarPDPOld.vue?vue&type=style&index=0&id=17a69b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a69b90",
  null
  
)

export default component.exports